import AuthLayout from '../../../components/AuthLayout';
import ChangePasswordContainer from '../../../containers/Forget/ChangePassword';

export default function ChangePassword() {
  return (
    <AuthLayout maxWidth="xl" title="رابکس | فراموشی رمزعبور">
      <ChangePasswordContainer />
    </AuthLayout>
  );
}
